import React, { useEffect, useState } from "react";
// Local imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";
import { route } from "../global/route.global";
import { months } from "../global/var.global";
import Img from "../widgets/Img";

// Live imports
import axios from "axios";
import parse from "html-react-parser";
import moment from "moment";
import Loader from "react-loader-spinner";

import { withRouter, NavLink as Link } from "react-router-dom";

function AgamStatus() {
  const [asOfDate, setAsOfDate] = useState("");
  const [totalMembers, setTotalMembers] = useState(0);
  const [totalMembersByTown, setTotalMembersByTown] = useState([]);
  const [countByVenue, setCountByVenue] = useState([]);
  const [regsTotal, setRegsTotal] = useState(0);
  // total total_off_pre_reg_mco
  const [totalOffPreReg, setTotalOffPreReg] = useState(0);
  const [totalOffReg, setTotalOffReg] = useState(0);
  const [totalOffRegGuest, setTotalOffRegGuest] = useState(0);

  useEffect(() => {
    var _d = new Date();
    setAsOfDate(_d.toString().substring(0, 24));

    getResults();
    setInterval(() => {
      getResults();
    }, 50000);
  }, []);

  // format number with commas
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const getResults = async () => {
    const instance = axios.create({});
    await instance
      .post(route.root.agam, {
        year: moment().format("YYYY"),
      })
      .then(async (res) => {
        // var _rn = regsNorth;
        // var _rs = regsSouth;
        // var _total = _rn + _rs;
        // setRegsTotal(_total);

        const _res = res.data.data;
        console.log(_res);
        setTotalMembers(_res["total_members"]);
        setRegsTotal(_res["total_off_reg_mco"]);
        setTotalMembersByTown(_res["total_members_by_town"]);
        setTotalOffRegGuest(_res["total_off_reg_guest"]);
        setTotalOffReg(_res["total_off_reg_mco"]);
        setTotalOffPreReg(_res["total_off_pre_reg_mco"]);
        setCountByVenue(_res["venue"]);
        // setRegsNorth(_res["qmember_north"]);
        // setRegsSouth(_res["qmember_south"]);
        // setRegsTotal(_res["qmember"]);
        // console.log(_res["qmember_north"]);
        // console.log(_res["qmember_south"]);
        // console.log(res.data);

        // setResidentials(res.data.results)
        // setIsLoading(false)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>AGAM Registration Status</h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclassname="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/agam-status" activeclassname="active">
                          AGAM Registration Status
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-wrapper pt-5">
        <div className="container">
          <div className="section_heading text-right"></div>

          <div className="row">
            <div className="col-sm-12">
              <h3>MCO PER DISTRICT</h3>
              <p> As of {asOfDate}</p>
              <table className="table">
                <thead>
                  <tr>
                    <th>DISTRICT</th>
                    <th>MEMBER CONSUMERS</th>
                    <th>
                      MCO <br />
                      (Feb 22, 2026) / (Pre-Registration)
                    </th>
                    <th>GUEST REGISTRATIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Add a loop for setTotalMembersByTown */}
                  {totalMembersByTown.map((town) => (
                    <tr key={town.district}>
                      <td>
                        {town.district} {town.name}
                      </td>
                      <td>{formatNumber(town.member_by_town)}</td>
                      <td>
                        {formatNumber(town.registration_by_town)} /{" "}
                        <>{formatNumber(town.pre_registration_by_town)}</>
                      </td>
                      <td>{formatNumber(town.guest_registration_by_town)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td>
                      <b>TOTAL</b>
                    </td>
                    <td>
                      <b>{formatNumber(totalMembers)}</b>
                    </td>
                    <td>
                      <b>{formatNumber(totalOffReg)}</b> /{" "}
                      <b>{formatNumber(totalOffPreReg)}</b>
                    </td>
                    <td>
                      <b>{formatNumber(totalOffRegGuest)}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>QUORUM</b>
                    </td>
                    <td>
                      <b>{formatNumber((totalMembers * 0.05).toFixed(0))}</b>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
              {/*  */}
              <h3>TOTAL</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>MCO</th>
                    <th>QUORUM</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>{formatNumber(totalMembers)}</td>
                    <td>
                      Target (
                      <b>{formatNumber((totalMembers * 0.05).toFixed(0))}</b>)
                    </td>
                  </tr>
                  <tr>
                    <td> </td>
                    <td>
                      Current (
                      <b>{formatNumber(totalOffPreReg + totalOffReg)}</b>)
                    </td>
                  </tr>
                </tbody>
              </table>
              {/*  */}
              <h3>VENUE</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>COUNT</th>
                  </tr>
                </thead>

                <tbody>
                  {/* Add a loop for setVenue */}
                  {countByVenue.map((v, index) => (
                    <tr key={index}>
                      <td>{v.name}</td>
                      <td>{formatNumber(v.count)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <CTAStrip />
    </>
  );
}

export default withRouter(AgamStatus);
